import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import mailStore from 'owa-mail-store/lib/store/Store';
import ReadingPaneStore from './schema/ReadingPaneStore';
import { createStore } from 'satcheljs';

import '../mutators/initializeItemReadingPaneViewStateMutator';
import '../mutators/updateLoadedItemStateMutator';

const INITIAL_READING_PANE_STORE: ReadingPaneStore = {
    conversationReadingPaneViewState: null,
    itemReadingPaneViewState: null,
    calendarViewEventRouteParams: null,
    itemPreviewViewState: null,
};

export const getReadingPaneStore = createStore<ReadingPaneStore>(
    'readingpane',
    INITIAL_READING_PANE_STORE
);
const store = getReadingPaneStore();

// Register the reading pane conversation with the conversation cache
conversationCache.registerReference(() => mailStore.mailModule.selectedId);

export default store;
